module.exports = __webpack_public_path__ + "media/src/components/GenerateDocument/images/error-circle-becb5171330e8097fffe80f9a8528bb7.png";